import type { PickemAction, PickemState } from '../types';

const initialState: PickemState = {
  pickems: [],
};

export const pickemsReducer = (
  state: PickemState,
  action: PickemAction
): PickemState => {
  let newState: PickemState;

  switch (action.type) {
    case 'SET_PICKEMS':
      newState = {
        ...state,
        pickems: action.payload.map((freshPickem) => {
          const existingPickem = state.pickems.find(
            (p) => p.id === freshPickem.id
          );

          return {
            ...freshPickem,
            selectedWinnerId: existingPickem?.selectedWinnerId,
          };
        }),
      };
      break;

    case 'SELECT_WINNER':
      newState = {
        ...state,
        pickems: state.pickems.map((pickem) => {
          const isTarget = pickem.id === action.payload.pickemId;
          return isTarget
            ? { ...pickem, selectedWinnerId: action.payload.winnerId }
            : pickem;
        }),
      };
      break;

    case 'CLEAR_ALL':
      // Instead of emptying the array, just clear all selections
      newState = {
        ...state,
        pickems: state.pickems.map((pickem) => ({
          ...pickem,
          selectedWinnerId: undefined,
        })),
      };
      break;

    default:
      console.warn('Unknown action type:', action);
      newState = state || initialState;
  }

  return newState;
};
